import { useState } from "react";
import MainLayout from "@/components/layout/MainLayout";
import PageHeader from "@/components/layout/PageHeader";
import VoiceCallsList from "@/components/voice/VoiceCallsListSimple";
import {
  VoiceCallDetailsSidebar,
  VoiceCallDetailsData,
} from "@/components/VoiceCallDetailsSidebar";

export default function VoiceCalls() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCall, setSelectedCall] = useState<VoiceCallDetailsData | null>(
    null,
  );
  const [loadingCallDetails, setLoadingCallDetails] = useState(false);

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
    setSelectedCall(null);
  };

  const handleCallClick = (callData: VoiceCallDetailsData) => {
    setSelectedCall(callData);
    setSidebarOpen(true);
  };

  return (
    <MainLayout>
      <PageHeader title="Calls" />

      <div className="flex flex-col flex-1 overflow-hidden">
        <VoiceCallsList
          onCallClick={handleCallClick}
          setLoadingCallDetails={setLoadingCallDetails}
        />
        <VoiceCallDetailsSidebar
          isOpen={sidebarOpen}
          onClose={handleCloseSidebar}
          callData={selectedCall}
          isLoading={loadingCallDetails}
          title="Call Details"
        />
      </div>
    </MainLayout>
  );
}
